import Http from "../../http/client";

export default async () => {
    const response = await Http.get('trip/matrix/heatmap');

    return response.data;
}
